export const urlFromBinary = (binary) => {
  if (!binary || binary.length === 0) {
    return null;
  }

  const blob = binary.get("blob");
  if (!blob) {
    return null;
  }

  return blob.url() || null;
};
